// extracted by mini-css-extract-plugin
export default {"TravelModeGroup":"TravelModeGroup_TravelModeGroup__J9+aa","rotation":"TravelModeGroup_rotation__15qNH"};